
import { mapGetters, mapState } from 'vuex';
import { TRAINING_STATUSES } from '~/helpers/constants';
import Pagination from '~/components/Pagination';
import '@fortawesome/fontawesome-free/css/all.css';

export default {
  name: 'Documents',
  components: { Pagination },
  layout: 'dashboard',
  data() {
    return {
      headers: [
        {
          text: 'Document type name',
          align: 'left',
          value: 'name',
          sortable: false
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status',
          sortable: false
        },
        {
          text: 'Training',
          value: 'training_room',
          align: 'center',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      trainingStatuses: TRAINING_STATUSES,
      loading: false,
      deleteDialog: false,
      progressDialog: false,
      progressText: '',
      documentData: {},
      documents: [],
      totalDocuments: 0,
      options: {},
      showCalendar: false,
      tableKey: 0
    };
  },
  computed: {
    ...mapState('user', ['user', 'usage']),
    ...mapGetters('billing', ['hasPaidSubscription'])
  },
  watch: {
    deleteDialog(value) {
      if (!value) this.documentData = {};
    }
  },
  mounted() {},
  methods: {
    openTrainingRoom(documentType) {
      this.$router.push({
        path: '/training-room/',
        query: {
          id: documentType.id
        }
      });
    },
    openDeleteDialog(item) {
      this.documentData = item;
      this.deleteDialog = true;
    },
    openModelsScreen(item) {
      this.$router.push({
        path: 'document-type/models/',
        query: { name: item.name }
      });
    },
    editDocument(item) {
      this.$router.push({
        path: 'document-type/edit/',
        query: { id: item.id }
      });
    },
    async deleteDocumentType() {
      try {
        this.deleteDialog = false;
        this.progressDialog = true;
        this.progressText = 'Deleting document type';
        await this.$axios.$post(
          `/api/document-types/${this.documentData.id}/start-removal/`
        );
        this.deleteDialog = false;
        this.forceTableRerender();
        this.documentData = {};
      } catch (err) {
        this.$snackbar.showMessage({
          content: `Error deleting document type ${this.documentType.name}`,
          color: 'success'
        });
        throw err;
      } finally {
        this.progressDialog = false;
      }
    },
    async trainModels({ url }) {
      try {
        this.loading = true;
        await this.$axios.$post(`${url}train/`);
        this.$snackbar.showMessage({
          content: 'Models put into training',
          color: 'info'
        });
      } catch (err) {
        let message;
        if (err.response?.status === 403) {
          message =
            err.response?.data?.details ||
            'You do not have permissions to train models. Upgrade your subscription';
        } else {
          message = `Error training models. Error message: ${err.message}`;
        }
        this.$snackbar.showMessage({
          content: message,
          color: 'error'
        });
      } finally {
        this.loading = false;
      }
    },
    forceTableRerender() {
      this.tableKey += 1;
    }
  }
};
